import {TrackingPromotionCreative} from '@aboutyou/legacy-tracking-sdk';
import React from 'react';
import {ElementTrackingContextProvider} from '../../../../tracking/context/ElementTrackingContext';
import {RenderPropChildren} from '../../../../tracking/trackerComponents/BaseTracker';
import {GenericPromotionTracker} from '../../../../tracking/trackerComponents/GenericPromotionTracker';

interface Props<RefType extends HTMLElement> {
  name: string;
  id: string;
  children?: RenderPropChildren<RefType>;
  url?: string;
}
function DropsPromotionTracking<RefType extends HTMLElement>(
  props: Props<RefType>,
) {
  const {name, id, children, url} = props;
  return (
    <ElementTrackingContextProvider>
      <GenericPromotionTracker
        name={name}
        id={id}
        resourceType={'hotdrop'}
        resourceId={id}
        url={url}
        source={'hotdrop' as TrackingPromotionCreative}
      >
        {children}
      </GenericPromotionTracker>
    </ElementTrackingContextProvider>
  );
}

export default DropsPromotionTracking;
